import DataTable from 'react-data-table-component'
import tableCustomStyles from './TableCustomeStyle'
import './style.css'
import RotatingLinesLoader from '../Loaders/RotatingLinesLoader'

const ReactDataTableWithoutPagination = ({
    data,
    columns,
    isSmallScreen,
    isLoading,
    isSelectableRows=false
}) => {
    return (
        <>
            <DataTable
                persistTableHead
                className={`${
                    isSmallScreen ? '' : 'scrollIssue table-custom-border'
                }`}
                customStyles={tableCustomStyles(isSelectableRows)}
                data={data}
                columns={columns}
                highlightOnHover
                responsive={true}
                progressPending={isLoading}
                noTableHead={isSmallScreen && true}
                progressComponent={<RotatingLinesLoader />}
            />
        </>
    )
}

export default ReactDataTableWithoutPagination
